<mat-card appearance="outlined" class="card">
  <mat-tab-group mat-align-tabs="center">
    <mat-tab label="Login">
      <h2>Login</h2>

      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="inputs">
          <mat-form-field>
            <input
              matInput
              formControlName="email"
              placeholder="Email"
              type="email"
              autocomplete="email"
            />
            <mat-error *ngIf="loginForm.controls.email.hasError('email') && !loginForm.controls.email.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="loginForm.controls.email.hasError('required')">
              Email is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="password"
              placeholder="Password"
              type="password"
              autocomplete="current-password"
            />
            <mat-error *ngIf="loginForm.controls.password.hasError('required')">
              Password is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="loginForm.controls.password.hasError('minlength')">
              Password must be at least <strong>8</strong> characters
            </mat-error>
          </mat-form-field>
        </div>
        <!--
          https://github.com/angular/components/issues/27118
          Known issue with button height less than the associated touch area, so set button height equal to touch area height
        -->
        <button mat-raised-button color="primary" type="submit" [disabled]="loading || (loginDisabled$ | async)" style="height: 48px;">
          Login
        </button>
      </form>
    </mat-tab>

    <mat-tab label="Register">
      <h2>Register</h2>

      <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
        <div class="inputs">
          <mat-form-field>
            <input
              matInput
              formControlName="name"
              placeholder="Name"
              autocomplete="name"
            />
            <mat-error *ngIf="registerForm.controls.email.hasError('required')">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="email"
              placeholder="Email"
              type="email"
              autocomplete="email"
            />
            <mat-error *ngIf="registerForm.controls.email.hasError('email') && !registerForm.controls.email.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="registerForm.controls.email.hasError('required')">
              Email is <strong>required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="password"
              placeholder="Password"
              type="password"
              autocomplete="new-password"
            />
            <mat-error *ngIf="registerForm.controls.password.hasError('required')">
              Password is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="registerForm.controls.password.hasError('minlength')">
              Password must be at least <strong>8</strong> characters
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="confirmation"
              placeholder="Confirm password"
              type="password"
              autocomplete="new-password"
            />
            <mat-error *ngIf="registerForm.value.password !== registerForm.value.confirmation">
              Password confirmation does not match
            </mat-error>
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" type="submit" [disabled]="loading || (registerDisabled$ | async)" style="height: 48px;">
          Register
        </button>
      </form>
    </mat-tab>

    <mat-tab label="Reset password">
      <h2>Reset password</h2>

      <form *ngIf="!passwordResetSent" [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()">
        <div class="inputs">
          <mat-form-field>
            <input
              matInput
              formControlName="email"
              placeholder="Email"
              type="email"
              autocomplete="email"
            />
            <mat-error *ngIf="resetPasswordForm.controls.email.hasError('email') && !resetPasswordForm.controls.email.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="resetPasswordForm.controls.email.hasError('required')">
              Email is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" type="submit" [disabled]="loading || (resetPasswordDisabled$ | async)" style="height: 48px;">
          Reset password
        </button>
      </form>

      <p *ngIf="passwordResetSent">
        Yay! You should receive an email with a link to reset your password.
      </p>
    </mat-tab>
  </mat-tab-group>
</mat-card>
